import React from "react";
import { Box, CardProps, Card, CardContent, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";

const useStyles = makeStyles((theme) => ({
  workoutContainer: {
    backgroundColor: colorSystem.blue5,
    borderRadius: 8,
    padding: theme.spacing(2.5),
    cursor: "pointer",
    width: "100%",
    boxShadow: "none",
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  title: {
    width: "50%",
    height: 20,
    marginBottom: theme.spacing(0.8),
  },
  subtitle: {
    width: "40%",
    height: 16,
  },
  footer: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    gap: theme.spacing(3),
  },
  footerItem: {
    width: 60,
    height: 16,
  },
}));
export interface WorkoutResultsSkeletonCard extends CardProps {}

export function WorkoutResultsSkeletonCard(props: WorkoutResultsSkeletonCard) {
  const s = useStyles();

  return (
    <Card className={s.workoutContainer}>
      <Box className={s.header}>
        <Skeleton variant="text" animation="wave" className={s.title} />
        <Skeleton variant="text" animation="wave" className={s.subtitle} />
      </Box>
      <Box className={s.footer}>
        <Skeleton variant="text" animation="wave" className={s.footerItem} />
        <Skeleton variant="text" animation="wave" className={s.footerItem} />
      </Box>
    </Card>
  );
}
